import { Capacitor } from "@capacitor/core";
import { Animation, createAnimation } from "@ionic/angular/standalone";

export const pageTransitionAnimations = (_baseEl: HTMLElement, options: { enteringEl: HTMLElement; leavingEl: HTMLElement; direction?: string }): Animation => {
  const isNativePlatform = Capacitor.isNativePlatform();
  const DURATION = isNativePlatform ? 300 : 400;

  const enteringEl = options.enteringEl;
  const leavingEl = options.leavingEl;
  const isBackDirection = options.direction === "back";

  const rootTransition = createAnimation().addElement(enteringEl).duration(DURATION).easing("ease").beforeRemoveClass("ion-page-invisible");

  const enteringContentAnimation = createAnimation().addElement(enteringEl);
  const leavingContentAnimation = createAnimation().addElement(leavingEl);

  //   Native platform
  if (isNativePlatform) {
    if (isBackDirection) {
      enteringContentAnimation.fromTo("transform", "translateX(-100vw)", "translateX(0%)").fromTo("opacity", "0", "1");
      leavingContentAnimation.fromTo("transform", "translateX(0%)", "translateX(100vw)").fromTo("opacity", "1", "0");
    } else {
      enteringContentAnimation.fromTo("transform", "translateX(100vw)", "translateX(0%)").fromTo("opacity", "0", "1");
      leavingContentAnimation.fromTo("transform", "translateX(0%)", "translateX(-100vw)").fromTo("opacity", "1", "0");
    }
  } else {
    //
    if (isBackDirection) {
      enteringContentAnimation
        .fromTo("transform", "translateX(-50px)", "translateX(0%)")
        .fromTo("opacity", "0", "1")
        .duration(DURATION / 2);
      leavingContentAnimation
        .fromTo("transform", "translateX(0%)", "translateX(50px)")
        .fromTo("opacity", "1", "0")
        .duration(DURATION / 2);
    } else {
      enteringContentAnimation
        .fromTo("transform", "translateX(50px)", "translateX(0%)")
        .fromTo("opacity", "0", "1")
        .duration(DURATION / 2);
      leavingContentAnimation
        .fromTo("transform", "translateX(0%)", "translateX(-50px)")
        .fromTo("opacity", "1", "0")
        .duration(DURATION / 2);
    }
  }

  rootTransition.addAnimation(enteringContentAnimation);
  rootTransition.addAnimation(leavingContentAnimation);

  return rootTransition;
};
